import { IconCircleCheckmarkOutline } from '@icons/IconCircleCheckmarkOutline'
import { IconCommentOutline } from '@icons/IconCommentOutline'
import { IconReturnOutline } from '@icons/IconReturnOutline'
import { IconTransformOutline } from '@icons/IconTransformOutline'
import { Button } from '@/components/shadcn/button'
import { Textarea } from '@/components/shadcn/textarea'
import { useState } from 'react'
import { ActivityLogV2Props } from '../ActivityLogV2'
import { RestSchemas } from '@/contexts/QueryProvider'
import clsx from 'clsx'
import { stateMap } from '../../stateMap'
import { NextStepHeading } from './NextStepHeading'
import { useAppContext } from '@/catalog-apps/hooks/useAppContext'
import { usePostTransitionUpdate } from './usePostTransitionUpdate'
import { ReturnFileComponent } from './ReturnFileComponent'
import { IconV2CorrectOutline } from '@icons/IconV2CorrectOutline'
import { IconV2ArrowLeftOutline } from '@icons/IconV2ArrowLeftOutline'
import { IconV2CommentOutline } from '@icons/IconV2CommentOutline'
type LogItem = RestSchemas['Messages.Templates.TTemplateActivity']

export function ReviewAction({ entityId, templateId, lastActivity }: ActivityLogV2Props & { lastActivity: LogItem }) {
  const { appId, projectId } = useAppContext()
  const { file_template } = lastActivity
  const { allow_comment, allow_return, allow_accept } = file_template
  const { mutate: transitionUpdate, isPending } = usePostTransitionUpdate({ entityId, templateId })
  const [componentState, setComponentState] = useState<'return' | 'reply' | 'none'>('none')
  const [comment, setComment] = useState('')

  const handleSendReply = () => {
    if (!appId || !projectId) return
    const formData = new FormData()
    formData.append('application_id', appId.toString())
    formData.append('project_id', projectId.toString())
    formData.append('entity_id', entityId.toString())
    formData.append('template_id', templateId.toString())
    formData.append('transition', 'Comment')
    if (comment) formData.append('notes', comment)
    transitionUpdate({ formData })
    setComponentState('none')
  }

  // const handleConfirmReturn = () => {
  //   // TODO: Confirm return
  //   setComponentState('none')
  // }

  const handleConfirmAccept = () => {
    if (!appId || !projectId) return
    const formData = new FormData()
    formData.append('application_id', appId.toString())
    formData.append('project_id', projectId.toString())
    formData.append('entity_id', entityId.toString())
    formData.append('template_id', templateId.toString())
    formData.append('transition', 'Accept')
    transitionUpdate({ formData })
    setComponentState('none')
  }

  const handleCancel = () => {
    setComponentState('none')
    setComment('')
  }

  const handleCancelReturn = () => {
    setComponentState('none')
  }

  if (isPending)
    return (
      <div className="flex w-full items-center justify-center gap-x-2 py-6">
        <IconTransformOutline className="size-6 animate-spin text-primary" />
        <p className="text-sm">Uploading...</p>
      </div>
    )

  return (
    <>
      <NextStepHeading>Review file</NextStepHeading>
      {componentState === 'none' && (
        <div className="flex gap-1">
          <Button disabled={!allow_accept} variant="outline" className="h-7" size="sm" onClick={handleConfirmAccept}>
            {/* <IconCircleCheckmarkOutline className={clsx('mr-1 size-3', stateMap.Accepted.color)} /> */}
            <IconV2CorrectOutline className="mr-1 size-3" />
            Accept file
          </Button>
          <Button
            disabled={!allow_return}
            variant="outline"
            className="h-7"
            size="sm"
            onClick={() => setComponentState('return')}
          >
            {/* <IconReturnOutline className={clsx('mr-1 size-3', stateMap.Returned.color)} /> */}
            <IconV2ArrowLeftOutline className="mr-1 size-3" />
            Return file
          </Button>
          <Button
            disabled={!allow_comment}
            variant="outline"
            className="h-7"
            size="sm"
            onClick={() => setComponentState('reply')}
          >
            {/* <IconCommentOutline className={clsx('mr-1 size-3', stateMap.None.color)} /> */}
            <IconV2CommentOutline className="mr-1 size-3" />
            Reply
          </Button>
        </div>
      )}
      {componentState === 'reply' && (
        <div className="flex flex-col gap-y-2">
          <Textarea placeholder="Type your reply" value={comment} onChange={(e) => setComment(e.target.value)} />
          <div className="flex justify-end gap-x-2">
            <Button size="sm" className="h-7" onClick={handleCancel} variant="outline">
              Cancel
            </Button>
            <Button size="sm" className="h-7" onClick={handleSendReply} variant="outline">
              Send
            </Button>
          </div>
        </div>
      )}
      {componentState === 'return' && (
        <ReturnFileComponent entityId={entityId} templateId={templateId} onCancel={handleCancelReturn} />
      )}
      {/* {componentState === 'return' && (
        <div className="flex flex-col gap-y-2">
          <p className="text-xs text-destructive">
            You are about to return a file that has completed the acceptance process. Please provide clear reasons for
            your decision.
          </p>
          <Textarea placeholder="Reasons for returning file" />
          <div className="flex justify-end gap-x-2">
            <Button size="sm" className="h-7" onClick={handleCancel} variant="outline">
              Cancel
            </Button>
            <Button size="sm" className="h-7" onClick={handleConfirmReturn} variant="outline">
              Confirm
            </Button>
          </div>
        </div>
      )} */}
    </>
  )
}
